import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {Tab, Table, Dimmer, Icon, Loader, Pagination, Input} from 'semantic-ui-react'
import accounting from 'accounting';
import moment from 'moment';
import {Link} from 'react-router-dom'
import {api} from '../../../api'

class OrderHistoryTab extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            paginated: {
                current_page: 1,
                data: [],
                first_page_url: "",
                from: 1,
                last_page: 1,
                last_page_url: "",
                next_page_url: null,
                path: "",
                per_page: 15,
                prev_page_url: null,
                to: 1,
                total: 1
            },
            search: ""
        }
    }

    componentDidMount () {
        this.setState({
            loading: true
        }, () => {
            this.fetchRecords(this.state.search, this.state.paginated.current_page);
        })
    }

    fetchRecords = (search, page) => {
        const {jwt, id} = this.props;
        api.relation.history(jwt,id, search, page).then(res => {
            this.setState({
                loading: false,
                paginated: res.data.data
            })
        }).catch(err => {
            this.setState({
                loading: false
            })
        })
    }

    onPageChange = (e, {activePage}) => {
        this.setState({
            loading: true
        }, () => {
            this.fetchRecords(this.state.search, activePage);
        })
    }

    onSearchIconClick = () => {
        this.setState({
            loading: true
        }, () => {
            this.fetchRecords(this.state.search, 1);
        })
    }
    
    onSearchKeyPressed = (e) => {
        if (e.key === 'Enter') {
            this.onSearchIconClick();
        }
    }

    getRoutingLink = (record) => {
        const {order} = record;
        if (!order) {
            return "/"
        }
        const {id, type} = order;
        let routeType = 'customer-orders';
        if (type === 'Customer Return') {
            routeType = 'customer-returns';
        }
        return `/${routeType}/${id}/view`;
    }

    render() {
        return (
            <Tab.Pane>
                <div className="row">
                    <div className="col-md-12">
                        <Input icon={<Icon name='search' inverted circular link onClick={() => {
                            this.onSearchIconClick()
                        }}/>} 
                            value={this.state.search}
                            onChange={(e, data) => {
                                this.setState({
                                    search: data.value
                                })
                            }}
                            onKeyPress={(e) => {this.onSearchKeyPressed(e)}}
                            placeholder='Search by inventory SKU' />
                    </div>
                </div>
                <div className="row" style={{marginTop: '10px'}}>
                    <div className="col-md-12">
                        {this.state.loading ? <Dimmer active inverted>
                            <Loader inverted content='Loading' />
                        </Dimmer> : <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>SO</Table.HeaderCell>
                                    <Table.HeaderCell>Ordered On</Table.HeaderCell>
                                    <Table.HeaderCell>Status</Table.HeaderCell>
                                    <Table.HeaderCell>SKU</Table.HeaderCell>
                                    <Table.HeaderCell>Item</Table.HeaderCell>
                                    <Table.HeaderCell>Qty</Table.HeaderCell>
                                    <Table.HeaderCell>Price</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.paginated.data.map(r => {
                                    return <Table.Row key={r.id}>
                                        <Table.Cell>
                                            <Link to={this.getRoutingLink(r)}>
                                                {r.order ? r.order.so : ""}
                                            </Link>
                                        </Table.Cell>
                                        <Table.Cell>{r.order ? moment(r.created_at).format('MMM D, Y').toString() : ""}</Table.Cell>
                                        <Table.Cell>{r.order ? r.order.status : ""}</Table.Cell>
                                        <Table.Cell>{r.inventory ? r.inventory.sku : ""}</Table.Cell>
                                        <Table.Cell>{r.inventory ? r.inventory.name : ""}</Table.Cell>
                                        <Table.Cell>{r.quantity}</Table.Cell>
                                        <Table.Cell>{accounting.formatMoney(r.price)}</Table.Cell>
                                    </Table.Row>
                                })}
                            </Table.Body>
                        </Table>}
                    </div>
                </div>
                <div className="row" style={{marginTop: '10px'}}>
                    <div className="col-md-12">
                        <Pagination
                            defaultActivePage={this.state.paginated.current_page}
                            totalPages={this.state.paginated.last_page}
                            onPageChange={(e, data) => {
                                this.onPageChange(e,data);
                            }}
                        />
                    </div>
                </div>
            </Tab.Pane>
        )
    }
}

OrderHistoryTab.propTypes = {
    id: PropTypes.number.isRequired,
    jwt: PropTypes.string.isRequired
};


export default OrderHistoryTab


// WEBPACK FOOTER //
// ./src/components/relations/parts/OrderHistoryTab.js